import React, { Component } from 'react';
import { NavLink, withRouter } from "react-router-dom";
import './NavBar.css';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Notifications from '../../components/Notifications/notifications';
import axios from 'axios';
import { APIURL, VERSION, VERSION_DATE } from '../../config';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import Badge from '@mui/material/Badge';
import { Dialog, DialogTitle, DialogContent, Button, DialogActions, InputBase, MenuItem, Paper } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import WhatsNew from '../WhatsNew/WhatsNew';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';


class NavBar extends Component {
    state = {
        anchorEl: null,
        anchorElAbout: null,
        newNotificationAlert: false,
        numberNotifRecorded: 0,
        whatsNewVersionsCount: 0,
        isDialogOpen: false,
        logoSrc: this.props.user.company_logo ? this.props.user.company_logo : './FieldworkerIcon.png',
        searchQuery: '',
        searchResults: [],
        searchLoading: false,
        assignedPrograms: [],
    }

    _searchDebounce = null;
    _searchSeq = 0;
    _dataCache = null;
    _dataCacheCompId = null;

    // function handles the pop-up help window 
    PopUpHelp() {
        window.open('https://fieldworker.gitbook.io/fieldworker-docs/', 'Data', 'height=700,width=1000');
    }
    handleClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleOpenDialog = () => {
        this.setState({ isDialogOpen: true });
    };

    handleCloseDialog = () => {
        this.setState({ isDialogOpen: false });
    };

    // alertNotification = () => {
    //     this.setState({newNotificationAlert: !this.state.newNotificationAlert})
    // }

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleClickAbout = (event) => {
        this.setState({ anchorElAbout: event.currentTarget });
    };

    handleCloseAbout = () => {
        this.setState({ anchorElAbout: null });
    };

    getNotifData = async () => {
        try{
        let notificationsData = await axios.get(APIURL + '/notifications', {params : {rec_id: this.props.user.emp_id, send_id: this.props.user.emp_id}})
        let numberNotifs = notificationsData.data.filter((notif)=> !notif.isRead).length
        return numberNotifs
        }catch(err){
            return 0
        }
    }

    componentDidMount = async () => {
        let numberNotifRecorded = await this.getNotifData()
        this.setState({ numberNotifRecorded })

        let whatsNewUpdatesCount = await axios.get(APIURL + '/system/whatsnewcount', {params : {}})
        console.log(whatsNewUpdatesCount)
        this.setState({ whatsNewVersionsCount: whatsNewUpdatesCount.data.NumberOfVersions })
        await this.loadAssignedPrograms();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user?.emp_id !== this.props.user?.emp_id || prevProps.user?.comp_id !== this.props.user?.comp_id) {
            this.loadAssignedPrograms();
        }
    }

    loadAssignedPrograms = async () => {
        if (!this.props.isAuth || !this.props.user?.emp_id || !this.props.user?.comp_id) {
            this.setState({ assignedPrograms: [] });
            return;
        }

        try {
            const [programsRes, assocRes] = await Promise.all([
                axios.get(`${APIURL}/programs`, { params: { company_id: this.props.user.comp_id } }),
                axios.get(`${APIURL}/programs/associations`, {
                    params: {
                        entity_type: 'employee',
                        entity_id: String(this.props.user.emp_id),
                    },
                }),
            ]);

            const allPrograms = Array.isArray(programsRes.data) ? programsRes.data : [];
            const associations = Array.isArray(assocRes.data) ? assocRes.data : [];
            const assignedProgramIds = new Set(associations.map((a) => String(a.program_id)));

            const isAdmin = String(this.props.user?.type || '').toLowerCase() === 'admin';
            const assignedPrograms = isAdmin
                ? allPrograms
                : allPrograms.filter((p) => assignedProgramIds.has(String(p.program_id)));

            const selectedStillValid = assignedPrograms.some(
                (p) => String(p.program_id) === String(this.props.selectedProgramId)
            );
            if (this.props.selectedProgramId && !selectedStillValid && this.props.onProgramChange) {
                this.props.onProgramChange(null);
            }

            this.setState({ assignedPrograms });
        } catch (err) {
            console.error('Failed to load assigned programs', err);
            this.setState({ assignedPrograms: [] });
        }
    }

    onFocus = async() =>  {
        let numberNotifRecorded = await this.getNotifData()
        console.log(numberNotifRecorded,this.state.numberNotifRecorded)
        console.log('When i run i ask for notifications')
        if(numberNotifRecorded - this.state.numberNotifRecorded > 0){
            this.setState({numberNotifRecorded: numberNotifRecorded, newNotificationAlert: (numberNotifRecorded - this.state.numberNotifRecorded <= 0)?false:true})
        }else{
            this.setState({numberNotifRecorded: numberNotifRecorded, newNotificationAlert: false})
        }
    }

    handleSearchChange = (e, value, reason) => {
        if (reason === 'input') {
            this.setState({ searchQuery: value });
            if (this._searchDebounce) clearTimeout(this._searchDebounce);
            if (value.trim().length < 2) {
                this.setState({ searchResults: [], searchLoading: false });
                return;
            }
            this._searchDebounce = setTimeout(() => this.performSearch(value), 250);
        }
    };

    performSearch = async (query) => {
        const seq = ++this._searchSeq;
        this.setState({ searchLoading: true });
        try {
            const compId = this.props.user.comp_id;
            if (!this._dataCache || this._dataCacheCompId !== compId) {
                const [cusRes, projRes, conRes] = await Promise.all([
                    axios.get(APIURL + '/customers/v2', { params: { company_id: compId } }),
                    axios.get(APIURL + '/dropdowns/dropdownType/projectslist', { params: { comp_id: compId } }),
                    axios.get(APIURL + '/contacts', { params: { comp_id: compId } }),
                ]);
                this._dataCache = {
                    customers: cusRes.data || [],
                    projects: projRes.data || [],
                    contacts: Array.isArray(conRes.data) ? conRes.data : [],
                };
                this._dataCacheCompId = compId;
            }
            if (seq !== this._searchSeq) return;
            const now = new Date();
            const term = new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
            const activeProjects = this._dataCache.projects.filter(
                p => p.start_date && p.end_date && new Date(p.end_date) >= now
            );
            const customerResults = this._dataCache.customers
                .filter(c => term.test(c.cus_name))
                .slice(0, 5)
                .map(c => ({ ...c, _type: 'customer', _label: c.cus_name, _group: 'Clients' }));
            const projectResults = activeProjects
                .filter(p => term.test(p.pname))
                .slice(0, 5)
                .map(p => ({ ...p, pro_id: p.pid, _type: 'project', _label: p.pname, _group: 'Projects' }));
            const contactResults = this._dataCache.contacts
                .filter(c => term.test(c.contact_name || ''))
                .map(c => ({ ...c, con_id: c.id || c.con_id, _type: 'contact', _label: c.contact_name, _group: 'Contacts' }))
                .slice(0, 5);
            this.setState({ searchResults: [...customerResults, ...projectResults, ...contactResults], searchLoading: false });
        } catch (err) {
            console.error('Search error:', err);
            this._dataCache = null;
            if (seq === this._searchSeq) this.setState({ searchLoading: false });
        }
    };

    handleSearchResultClick = (type, item) => {
        this.setState({ searchQuery: '', searchResults: [] });
        if (type === 'customer') {
            this.props.history.push({
                pathname: '/customers',
                customersProps: { cus_id: item.cus_id, edit: false },
            });
        } else if (type === 'project') {
            this.props.history.push({
                pathname: '/projects',
                projectsProps: { pro_id: item.pro_id, cus_id: item.cus_id },
            });
        } else if (type === 'contact') {
            this.props.history.push({
                pathname: '/contacts',
                contactsProps: { con_id: item.con_id },
            });
        }
    };

    render() {
        const open = Boolean(this.state.anchorEl);
        const id = open ? 'simple-popover' : undefined;
        const iconForType = { customer: 'fa-user', project: 'fa-folder', contact: 'fa-address-card' };
        return (
            <header id="login-navbar">
                <AppBar position='fixed' onFocus={this.onFocus} style={{ zIndex: 2 }}>
                    <Toolbar className="navbar navbar-expand-lg navbar-light" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>

                        {/* LEFT — Logo + Company + What's New */}
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexShrink: 0 }}>
                            <Icon sx={{ height: 60, width: 60, color: '#95D0EB', ml: "-16px", mt: "-15px" }}>
                                <NavLink to="/" className="navbar-brand">
                                    <img src={this.state.logoSrc} alt="logo" style={{ height: 60, width: 60 }} onError={(e) => this.setState({ logoSrc: './FieldworkerIcon.png' })} />
                                </NavLink>
                            </Icon>
                            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: "5px" }}>
                                <ul style={{ padding: 0 }} className="navbar-brand navbar-nav mr-auto">
                                    <li style={{ padding: 0 }} className="nav-item dropdown">
                                        <Typography variant='h6' style={{ color: '#3FA7D6', alignSelf: "center" }} className="nav-link dropdown-toggle" href="/" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <a style={{ color: '#3FA7D6' }}>
                                                {this.props.user.company_name ? this.props.user.company_name : 'Analytiq Inc'}
                                            </a>
                                        </Typography>
                                        <div className="dropdown-menu" id="navbar-dropdown" aria-labelledby="navbarDropdown">
                                            {this.props.isAuth && <NavLink to="/empDashboards" className="dropdown-item">Employee Analytics</NavLink>}
                                            {this.props.isAuth && <NavLink to="/team" className="dropdown-item">Team</NavLink>}
                                            <div className="dropdown-divider"></div>
                                            {!this.props.isAuth && <button className="dropdown-item login-button" onClick={this.props.login}>Login</button>}
                                            {this.props.isAuth && <button className="dropdown-item" onClick={this.props.logout}>Logout</button>}
                                        </div>
                                    </li>
                                </ul>
                                <Typography variant="caption" sx={{ lineHeight: '0.5', fontSize: '12px', padding: '0', color: '#95D0EB', alignSelf: "center" }}>Powered by FieldWorker</Typography>
                            </div>
                            <div style={{ marginLeft: '10px' }}>
                                <Button onClick={this.handleOpenDialog} style={{ margin: '0px', padding: '0px' }}>
                                    <Badge badgeContent={this.state.whatsNewVersionsCount} color="primary">
                                        <SystemUpdateAltIcon style={{ color: '#95D0EB' }} />
                                    </Badge>
                                </Button>
                                <Dialog
                                    open={this.state.isDialogOpen}
                                    onClose={this.handleCloseDialog}
                                    PaperProps={{ style: { width: '60%', height: '60%', maxWidth: 'none' } }}
                                >
                                    <DialogTitle>
                                        What's New in FieldWorker
                                        <IconButton aria-label="close" onClick={this.handleCloseDialog} style={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}>
                                            <CloseIcon />
                                        </IconButton>
                                        <hr />
                                    </DialogTitle>
                                    <DialogContent>
                                        <WhatsNew props={this.props} checkTokenExpiry={this.props.checkTokenExpiry} user={this.props.user} comp_id={this.props.user.comp_id} />
                                    </DialogContent>
                                    <DialogActions sx={{ borderTop: '1px solid #d3d3d3' }}>
                                        <Button onClick={this.handleCloseDialog} color="primary">Cancel</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        </div>

                        {/* CENTER — Global Search */}
                        {this.props.isAuth && (
                            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                                <Autocomplete
                                    freeSolo
                                    clearOnEscape
                                    options={this.state.searchResults}
                                    groupBy={(opt) => opt._group}
                                    getOptionLabel={(opt) => (typeof opt === 'string' ? opt : opt._label)}
                                    inputValue={this.state.searchQuery}
                                    onInputChange={this.handleSearchChange}
                                    onChange={(e, opt) => {
                                        if (opt && typeof opt === 'object') {
                                            this.handleSearchResultClick(opt._type, opt);
                                        }
                                    }}
                                    loading={this.state.searchLoading}
                                    loadingText="Searching…"
                                    noOptionsText={this.state.searchQuery.trim().length < 2 ? 'Type to search…' : 'No matches'}
                                    filterOptions={(x) => x}
                                    isOptionEqualToValue={(opt, val) => opt._type === val._type && opt._label === val._label}
                                    renderOption={(props, opt) => (
                                            <li {...props} key={`${opt._type}-${opt.cus_id ?? opt.pro_id ?? opt.con_id}`} style={{ fontSize: 14 }}>
                                            <i className={`fas ${iconForType[opt._type]}`} style={{ color: '#3FA7D6', width: 18, marginRight: 8 }} />
                                            {opt._label}
                                        </li>
                                    )}
                                    sx={{ width: '100%', maxWidth: 460 }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Search clients, projects, or contacts…"
                                            variant="outlined"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <>
                                                        <SearchIcon sx={{ color: '#6b7a99', mr: 0.5, fontSize: 20 }} />
                                                        {params.InputProps.startAdornment}
                                                    </>
                                                ),
                                                sx: {
                                                    borderRadius: '24px',
                                                    backgroundColor: '#f0f4f8',
                                                    fontSize: 14,
                                                    '& fieldset': { borderColor: '#dde3ed' },
                                                    '&:hover fieldset': { borderColor: '#3FA7D6' },
                                                    '&.Mui-focused fieldset': { borderColor: '#3FA7D6' },
                                                },
                                            }}
                                        />
                                    )}
                                />
                                <TextField
                                    select
                                    size="small"
                                    value={this.props.selectedProgramId || ''}
                                    onChange={(e) => this.props.onProgramChange && this.props.onProgramChange(e.target.value || null)}
                                    sx={{
                                        width: 230,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '24px',
                                            backgroundColor: '#f0f4f8',
                                            fontSize: 14,
                                            '& fieldset': { borderColor: '#dde3ed' },
                                            '&:hover fieldset': { borderColor: '#3FA7D6' },
                                            '&.Mui-focused fieldset': { borderColor: '#3FA7D6' },
                                        },
                                    }}
                                    SelectProps={{ displayEmpty: true }}
                                >
                                    <MenuItem value="">All Programs</MenuItem>
                                    {this.state.assignedPrograms.map((program) => (
                                        <MenuItem key={program.program_id} value={program.program_id}>
                                            {program.program_name || `Program #${program.program_id}`}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        )}

                        {/* MOBILE TOGGLER */}
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {/* RIGHT — User info + action icons */}
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav ml-auto">
                                {this.props.isAuth &&
                                    <li style={{ padding: 1, paddingTop: 10, color: 'black' }} className="nav-item">
                                        <h6>Signed in using <span className="badge badge-info">{this.props.user.email}</span> as <span className="badge badge-info">{this.props.user.emp_name}</span></h6>
                                    </li>
                                }
                                {this.props.isAuth &&
                                    <div className="d-flex flex-md-row flex-sm-column">
                                        <li className="nav-item d-none">
                                            <NavLink to="/onboarding" className="nav-link"><i className="fas fa-table"></i></NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/reports" className="nav-link" title="Reports">
                                                <i className="fas fa-table"></i>
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink to="/settings" className="nav-link" title="Settings">
                                                <i className="fas fa-cog"></i>
                                            </NavLink>
                                        </li>
                                        <li className="feature-request-tooltip-nav-item">
                                            <a href="https://fieldworker.canny.io/feature-requests" className="nav-link">
                                                <i className="fas fa-clipboard m-0"></i>
                                            </a>
                                        </li>
                                        <li className="helpcenter-tooltip-nav-item">
                                            <div className="nav-link"><i className="fas fa-question-circle" onClick={this.PopUpHelp} style={{ cursor: 'pointer' }}></i></div>
                                        </li>
                                        <li className="helpcenter-tooltip-nav-item">
                                            <div className="nav-link" style={{ width: '35px' }}></div>
                                        </li>
                                        <li className="about-tooltip-nav-item">
                                            <div
                                                className="nav-link"
                                                onMouseEnter={this.handleClickAbout}
                                                onMouseLeave={this.handleCloseAbout}>
                                                <i className="fas fa-info" style={{ cursor: 'pointer' }}></i>
                                            </div>
                                        </li>
                                        <div className='notification-tooltip-nav-item'>
                                            {!open && !this.state.newNotificationAlert && <i style={{ cursor: 'pointer', margin: 12, marginLeft: '5px', color: !this.state.anchorEl ? 'rgba(130, 130, 130, 1)' : '#000000' }} className={"fas fa-bell"} onClick={this.handleClick}><sup className='position-absolute top-0 start-0 translate-middle badge rounded-pill' style={{ color: 'white', margin: '1px', backgroundColor: '#FA7171', marginTop: '22px', fontSize: '10px' }}>{this.state.numberNotifRecorded === 0 ? '' : this.state.numberNotifRecorded}</sup></i>}
                                            {!!open && (!this.state.newNotificationAlert || !!this.state.newNotificationAlert) && <i style={{ margin: 12, marginLeft: '5px', color: 'rgba(130, 130, 130, 1)' }} className={"fas fa-bell"} onClick={this.handleClick}><sup className='position-absolute top-0 start-0 translate-middle badge rounded-pill' style={{ color: 'white', margin: '1px', backgroundColor: '#FA7171', marginTop: '22px', fontSize: '10px' }}>{this.state.numberNotifRecorded === 0 ? '' : this.state.numberNotifRecorded}</sup></i>}
                                            {!open && !!this.state.newNotificationAlert && <div className='d-flex flex-row'><img onClick={this.handleClick} style={{ margin: 12, marginLeft: '5px', height: '1rem', width: '1rem' }} src='../alertNotif.png' alt='alertNotif' /><sup className='position-absolute top-0 start-0 translate-middle badge rounded-pill' style={{ color: 'white', margin: '1px', backgroundColor: '#FA7171', marginTop: '22px', marginLeft: '20px', fontSize: '10px' }}>{this.state.numberNotifRecorded === 0 ? '' : this.state.numberNotifRecorded}</sup></div>}
                                            <Popover
                                                id={id}
                                                open={open}
                                                style={{ top: 30, left: window.innerWidth - 500, right: 5 }}
                                                anchorEl={this.state.anchorEl || null}
                                                onClose={this.handleClose}
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                            >
                                                <Notifications user={this.props.user} />
                                            </Popover>
                                        </div>
                                        <Popover
                                            id="mouse-over-popover"
                                            sx={{ pointerEvents: 'none', border: '2px solid gray', borderRadius: "2px", minWidth: "400px" }}
                                            open={Boolean(this.state.anchorElAbout)}
                                            anchorEl={this.state.anchorElAbout || null}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                            onClose={this.handleCloseAbout}
                                            disableRestoreFocus
                                        >
                                            <Typography sx={{ p: 1, pb: 0, fontSize: 14 }}><b>Version</b>  {VERSION}</Typography>
                                            <Typography sx={{ p: 1, fontSize: 14 }}><b>Release</b>  {VERSION_DATE}</Typography>
                                        </Popover>
                                    </div>
                                }
                            </ul>
                        </div>

                    </Toolbar>
                </AppBar>
            </header>
        );
    }

}

export default withRouter(NavBar);